import React from 'react';
import PropTypes from 'prop-types';
import { fieldInputPropTypes, fieldMetaPropTypes } from 'redux-form/immutable';

import formControl from './formControl';
import { floatToString, stringToFloat } from '../../lib/common';

// Takes currency in cents but displays in floats.
function FactorInput({ input: { value, onChange, onBlur, ...otherInputProps }, disabled }) {
  return (
    <input
      {...otherInputProps}
      className="form-control"
      value={value}
      type="text"
      placeholder="Faktor"
      onChange={event => onChange(event.target.value)}
      onBlur={event => onBlur(stringToFloat(event.target.value) || 0)}
      disabled={disabled}
    />
  );
}

FactorInput.format = value => floatToString(value, 6); // Should strip 0:s after comma-sign
FactorInput.defaultProps = {
  disabled: false,
};
FactorInput.propTypes = {
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  meta: PropTypes.shape(fieldMetaPropTypes).isRequired,
  disabled: PropTypes.bool,
};

export default formControl(FactorInput);
